var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "ec1a52e1-7cb7-4699-9d49-65d4ce9e6908"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "1ed7d604-ca4b-4bcd-b77a-06c6124edf6d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.02 -199)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 0.887
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-254.52, -56.38)",
    d: "M 249.5 40.5 C 253.946 39.6219 257.28 41.1219 259.5 45 C 260.499 50.6608 261.499 56.3275 262.5 62 C 262.489 68.3446 259.323 71.8446 253 72.5 C 250.117 71.415 248.117 69.415 247 66.5 C 245.93 57.6022 246.763 48.9355 249.5 40.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.76 23.11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 0.916
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-253.78, -278.49)",
    d: "M 244.5 86.5 C 309.423 85.5339 355.923 114.201 384 172.5 C 395.266 201.42 397.6 231.087 391 261.5 C 384.601 286.641 372.268 308.307 354 326.5 C 337.36 341.8 322.193 358.3 308.5 376 C 309.204 388.613 309.871 401.279 310.5 414 C 308.732 428.1 300.732 435.767 286.5 437 C 289.716 445.908 288.883 454.408 284 462.5 C 280.223 466.138 275.723 468.305 270.5 469 C 260.997 469.45 251.497 469.95 242 470.5 C 226.395 470.564 218.228 462.73 217.5 447 C 218.091 443.473 218.758 439.973 219.5 436.5 C 209.806 436.309 203.306 431.643 200 422.5 C 198.053 407.619 199.72 393.286 205 379.5 C 187.429 358.926 168.763 339.259 149 320.5 C 113.55 279.248 104.216 232.582 121 180.5 C 143.39 124.399 184.557 93.0654 244.5 86.5 Z M 245.5 101.5 C 299.248 100.282 339.748 122.615 367 168.5 C 391.351 219.67 386.351 267.67 352 312.5 C 334.84 331.669 319.007 351.835 304.5 373 C 282.213 372.998 259.879 373.665 237.5 375 C 227.175 375.727 217.009 377.227 207 379.5 C 204.135 371.438 200.469 363.771 196 356.5 C 181.761 339.684 167.761 322.684 154 305.5 C 123.446 261.025 120.446 214.691 145 166.5 C 167.866 128.321 201.366 106.654 245.5 101.5 Z M 270.5 135.5 C 277.502 135.084 283.002 137.751 287 143.5 C 287.809 149.133 288.975 154.633 290.5 160 C 291.609 160.638 292.775 161.138 294 161.5 C 298.313 159.34 302.813 157.673 307.5 156.5 C 318.408 158.324 322.908 164.657 321 175.5 C 313.614 187.489 317.114 192.989 331.5 192 C 340.492 196.496 342.826 203.33 338.5 212.5 C 336.007 214.58 333.341 216.414 330.5 218 C 326.229 221.244 325.562 225.078 328.5 229.5 C 339.794 234.225 342.627 241.891 337 252.5 C 332.128 255.958 326.628 257.458 320.5 257 C 316.139 259.226 314.639 262.726 316 267.5 C 322.462 275.208 321.962 282.375 314.5 289 C 310.961 290.504 307.295 290.837 303.5 290 C 290.537 282.255 284.703 286.089 286 301.5 C 281.731 310.386 275.231 312.552 266.5 308 C 264.622 306.457 263.122 304.624 262 302.5 C 261.5 286.503 261.333 270.503 261.5 254.5 C 269.529 255.641 277.529 255.641 285.5 254.5 C 287.288 256.791 289.288 258.957 291.5 261 C 294.03 262.422 296.697 262.755 299.5 262 C 300.804 261.196 301.471 260.029 301.5 258.5 C 300.601 255.303 299.601 252.136 298.5 249 C 299.472 246.889 300.305 244.722 301 242.5 C 305.448 239.716 310.115 237.383 315 235.5 C 316.865 227.575 313.698 223.575 305.5 223.5 C 295.466 224.541 289.132 229.874 286.5 239.5 C 278.134 239.791 269.801 240.457 261.5 241.5 C 260.778 216.832 259.944 192.165 259 167.5 C 258.616 160.774 257.783 154.107 256.5 147.5 C 259.689 141.635 264.355 137.635 270.5 135.5 Z M 207.5 381.5 C 236.738 384.54 266.072 386.207 295.5 386.5 C 295.666 395.506 295.5 404.506 295 413.5 C 294.932 416.319 293.766 418.486 291.5 420 C 267.23 421.637 242.896 421.971 218.5 421 C 215 420.167 212.833 418 212 414.5 C 211.156 403.388 209.656 392.388 207.5 381.5 Z M 230.5 436.5 C 246.503 436.333 262.503 436.5 278.5 437 C 277.426 442.174 276.26 447.341 275 452.5 C 272.711 453.986 270.211 454.986 267.5 455.5 C 257.194 454.713 246.86 454.213 236.5 454 C 235.667 453.167 234.833 452.333 234 451.5 C 232.64 446.53 231.473 441.53 230.5 436.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 120.46 -149.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 0.885
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-376, -105.45)",
    d: "M 383.5 91.5 C 385.39 91.2965 386.89 91.9632 388 93.5 C 388.236 95.764 388.736 97.9307 389.5 100 C 385.554 106.279 381.221 112.279 376.5 118 C 372.419 120.061 368.419 119.894 364.5 117.5 C 363.304 116.441 362.637 115.107 362.5 113.5 C 363 111.5 363.5 109.5 364 107.5 C 369.55 100.762 376.05 95.429 383.5 91.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -126.74 -148.76)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 0.883
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-128.81, -106.62)",
    d: "M 115.5 93.5 C 118.187 93.3359 120.854 93.5026 123.5 94 C 130.762 97.8787 137.595 102.379 144 107.5 C 147.14 117.791 143.64 121.624 133.5 119 C 124.307 113.974 117.307 106.807 112.5 97.5 C 113.524 96.1482 114.524 94.8149 115.5 93.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.54 -29.58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 0.915
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-254, -225.8)",
    d: "M 226.5 125.5 C 238.116 123.73 246.949 127.73 253 137.5 C 253.667 140.167 253.667 142.833 253 145.5 C 244.246 135.034 234.579 133.7 224 141.5 C 223.333 142.833 222.667 144.167 222 145.5 C 221.667 149.833 221.333 154.167 221 158.5 C 218.839 162.124 215.672 163.291 211.5 162 C 199.599 154.641 191.599 157.641 187.5 171 C 187.885 174.728 189.385 177.894 192 180.5 C 193.992 186.337 192.158 190.171 186.5 192 C 174.416 191.087 168.583 196.587 169 208.5 C 169.667 209.833 170.333 211.167 171 212.5 C 174.516 214.926 177.849 217.593 181 220.5 C 183.152 227.352 180.652 231.852 173.5 234 C 166.554 241.331 166.887 248.331 174.5 255 C 179.832 256.691 185.165 258.191 190.5 259.5 C 193.444 263.943 192.944 267.943 189 271.5 C 185.768 282.607 189.768 289.607 201 292.5 C 204.888 291.955 208.388 290.455 211.5 288 C 214.956 286.877 217.79 287.71 220 290.5 C 218.271 302.737 223.271 310.404 235 313.5 C 239.153 312.725 242.82 311.058 246 308.5 C 246.265 274.825 246.765 241.159 247.5 207.5 C 239.161 208.406 230.827 209.406 222.5 210.5 C 217.769 222.698 209.102 227.198 196.5 224 C 192.64 220.793 191.973 217.126 194.5 213 C 208.423 210.65 212.423 203.15 206.5 190.5 C 209.264 186.178 212.93 185.345 217.5 188 C 219.402 190.345 221.402 192.511 223.5 194.5 C 231.726 193.757 239.893 193.423 248 193.5 C 248.477 177.954 250.477 162.621 254 147.5 C 255.723 135.792 262.723 129.458 275 128.5 C 286.992 129.329 295.158 135.329 299.5 146.5 C 319.792 142.809 331.459 151.143 334.5 171.5 C 334.163 174.176 333.83 176.843 333.5 179.5 C 343.625 181.455 350.125 187.455 353 197.5 C 355.704 207.682 353.538 216.682 346.5 224.5 C 356.617 236.708 357.117 249.375 348 262.5 C 344.159 266.511 339.659 269.511 334.5 271.5 C 336.317 295.184 325.317 306.684 301.5 306 C 296.661 318.49 287.495 325.324 274 326.5 C 263.837 326.086 255.837 321.753 250 313.5 C 240.48 322.706 229.98 323.873 218.5 317 C 214.147 313.813 211.147 309.646 209.5 304.5 C 194.712 306.738 183.546 301.405 176 288.5 C 174.191 282.527 173.525 276.527 174 270.5 C 158.059 264.297 151.725 252.63 155 235.5 C 156.026 231.278 158.193 227.778 161.5 225 C 151.396 212.278 150.896 199.111 160 185.5 C 163.477 182.018 167.477 179.352 172 177.5 C 170.448 163.103 175.948 152.27 188.5 145 C 194.74 142.676 201.073 142.01 207.5 143 C 211.335 134.422 217.669 128.589 226.5 125.5 Z M 270.5 135.5 C 264.355 137.635 259.689 141.635 256.5 147.5 C 257.783 154.107 258.616 160.774 259 167.5 C 259.944 192.165 260.778 216.832 261.5 241.5 C 269.801 240.457 278.134 239.791 286.5 239.5 C 289.132 229.874 295.466 224.541 305.5 223.5 C 313.698 223.575 316.865 227.575 315 235.5 C 310.115 237.383 305.448 239.716 301 242.5 C 300.305 244.722 299.472 246.889 298.5 249 C 299.601 252.136 300.601 255.303 301.5 258.5 C 301.471 260.029 300.804 261.196 299.5 262 C 296.697 262.755 294.03 262.422 291.5 261 C 289.288 258.957 287.288 256.791 285.5 254.5 C 277.529 255.641 269.529 255.641 261.5 254.5 C 261.333 270.503 261.5 286.503 262 302.5 C 263.122 304.624 264.622 306.457 266.5 308 C 275.231 312.552 281.731 310.386 286 301.5 C 284.703 286.089 290.537 282.255 303.5 290 C 307.295 290.837 310.961 290.504 314.5 289 C 321.962 282.375 322.462 275.208 316 267.5 C 314.639 262.726 316.139 259.226 320.5 257 C 326.628 257.458 332.128 255.958 337 252.5 C 342.627 241.891 339.794 234.225 328.5 229.5 C 325.562 225.078 326.229 221.244 330.5 218 C 333.341 216.414 336.007 214.58 338.5 212.5 C 342.826 203.33 340.492 196.496 331.5 192 C 317.114 192.989 313.614 187.489 321 175.5 C 322.908 164.657 318.408 158.324 307.5 156.5 C 302.813 157.673 298.313 159.34 294 161.5 C 292.775 161.138 291.609 160.638 290.5 160 C 288.975 154.633 287.809 149.133 287 143.5 C 283.002 137.751 277.502 135.084 270.5 135.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -174.04 -27.39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 0.891
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-81.5, -227.99)",
    d: "M 82.5 220.5 C 91.0925 218.053 96.4259 221.053 98.5 229.5 C 97.6994 232.133 96.0327 233.967 93.5 235 C 83.6777 237.349 74.1777 236.516 65 232.5 C 64.3333 230.833 64.3333 229.167 65 227.5 C 66.353 226.315 67.5197 224.981 68.5 223.5 C 73.2906 222.491 77.9573 221.491 82.5 220.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 173.04 -27.37)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 0.892
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-428.58, -228.01)",
    d: "M 416.5 220.5 C 426.706 219.954 436.706 220.954 446.5 223.5 C 446.953 227.426 445.62 230.592 442.5 233 C 433.227 235.664 423.894 236.331 414.5 235 C 408.671 229.171 409.338 224.338 416.5 220.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -122.44 95.61)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 0.887
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-133.1, -350.98)",
    d: "M 135.5 336.5 C 140.732 336.174 144.398 338.341 146.5 343 C 142.335 353.998 134.668 361.498 123.5 365.5 C 120.26 362.949 119.093 359.615 120 355.5 C 124.239 348.322 129.406 341.989 135.5 336.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 120.46 95.66)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 0.888
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-376, -351.04)",
    d: "M 368.5 336.5 C 379.436 341.443 386.436 349.776 389.5 361.5 C 387.216 365.252 383.882 366.419 379.5 365 C 374.032 360.533 368.865 355.7 364 350.5 C 360.999 344.157 362.499 339.49 368.5 336.5 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/darkLogo.2cfdcd78f1a09d8d6072a356e14e9bb0.svg";
export { ForwardRef as ReactComponent };